import React from 'react';
import './styles.css';

function Footer() {
  return (
    <footer className="footer">
      <p>BRAND® and the Mysite logo are registered trademarks...</p>
      <div className="footer-links">
        <a href="#">Legal Notice</a>
        <a href="#">Privacy Policy</a>
        <a href="#">Contact Us</a>
        <a href="#">Cookie Policy</a>
      </div>
    </footer>
  );
}

export default Footer;
